import { render, staticRenderFns } from "./AmountInput.vue?vue&type=template&id=24ca06ce&scoped=true"
import script from "./AmountInput.vue?vue&type=script&lang=js"
export * from "./AmountInput.vue?vue&type=script&lang=js"
import style0 from "./AmountInput.vue?vue&type=style&index=0&id=24ca06ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca06ce",
  null
  
)

export default component.exports